const easeing = {
  easeInOutQuad: (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t + b;
    }
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  },

  easeInCubic: (t, b, c, d) => {
    const tc = (t /= d) * t * t;
    return b + c * tc;
  },

  inOutQuintic: (t, b, c, d) => {
    const ts = (t /= d) * t;
    const tc = ts * t;
    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
  },
};



const scrollTo = {

  getCurrentPosition: (container = null) => {
    if (container) {
      return container.scrollTop;
    }

    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
  },
  setCurrentPosition: (position, container = null) => {
    if (container) {
      container.scrollTop = position;
      return;
    }

    document.documentElement.scrollTop = position;
    document.body.parentNode.scrollTop = position;
    document.body.scrollTop = position;
  },
  element: (el, duration = 500, offset = 0, callback = null, container = null) => {
    const oldDisplay = el.style.display;
    if (oldDisplay === 'none') {
      el.style.display = 'block';
    }

    const to = (container ? el.offsetTop : el.getBoundingClientRect().top) + scrollTo.getCurrentPosition();

    el.style.display = oldDisplay;
    scrollTo.position(to, duration, offset, callback, container);
  },
  position: (to, duration = 500, offset = 0, callback = null, container = null) => {
    const start = scrollTo.getCurrentPosition(container);
    const change = to - start - offset;
    let currentTime = 0;
    const increment = 20;

    const animateScroll = () => {
      // increment the time
      currentTime += increment;
      // find the value with the quadratic in-out easing function
      const val = easeing.easeInOutQuad(currentTime, start, change, duration);
      // move the document.body
      scrollTo.setCurrentPosition(val, container);
      // do the animation unless its over
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      } else {
        if (callback && typeof callback === 'function') {
          // the animation is done so consts callback
          callback();
        }
      }
    };


    // because it's so fucking difficult to detect the scrolling element, just move them all

    animateScroll();
  },
};

export default scrollTo;



// WEBPACK FOOTER //
// ./scripts/util/scrollTo.js